<template>
  <div>
    <v-select
      v-model="currency"
      @input="handleInput"
      :label="$t('customer.create.currency')"
      :items="currencyList"
      :disabled="disabled"
      item-text="text"
      item-value="value"
      outlined
    >
      <template v-slot:selection="{ item }">
        {{ item.flag }}
        <strong class="pl-1">{{ item.symbol }}</strong>
      </template>
    </v-select>
  </div>
</template>

<script>
import { countriesList } from '@/util/enums'

export default {
  name: 'HCurrencySelect',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    country: {
      type: String,
      required: false,
    },

    defaultValue: {
      type: String,
      required: false,
    },
  },

  computed: {
    currency: {
      get() {
        if (this.defaultValue) return this.defaultValue
        if (this.country === 'BR' && !this.defaultValue) return 'BRAZILIAN_REAL'
        return 'AUSTRALIAN_DOLLAR'
      },
      set(value) {
        return value
      }
    },

    currencyList() {
      const list = []

      countriesList.map((item) => {
        list.push(
          {
            flag: item.flag,
            text: `${item.flag} ${item.currency_symbol} ${item.currency_label}`,
            symbol: item.currency_symbol,
            value: item.currency
          }
        )
      })

      return list
    }
  },

  watch: {
    currency() {
      this.$emit('input', this.currency)
    },

    // country() {
    //   this.$emit('input', this.currency)
    // }
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },
  }
}
</script>
